const headerSectionContent = {
  id: {
    notes: {
      active: 'Aplikasi Catatan',
      archived: 'Terarsip',
    },
  },
  en: {
    notes: {
      active: 'Notes App',
      archived: 'Archived',
    },
  },
};

const loginPageContent = {
  id: {
    header: 'Yuk, login untuk menggunakan aplikasi.',
    userState: 'Belum punya akun?',
    link: 'Daftar di sini',
  },
  en: {
    header: 'Login to use app, please.',
    userState: 'Don\'t have an account?',
    link: 'Register here',
  },
};
const registerPageContent = {
  id: {
    header: 'Isi form untuk mendaftar akun.',
    userState: 'Sudah punya akun?',
    link: 'Login di sini',
  },
  en: {
    header: 'Fill the form to register account.',
    userState: 'Already have an account?',
    link: 'Login here',
  },
};
const notesPageContent = {
  id: {
    notesType: {
      active: 'Catatan Aktif',
      archived: 'Catatan Arsip',
    },
    searchBar: 'Cari berdasarkan judul...',
    noteListInformation: 'Tidak ada catatan',
  },
  en: {
    notesType: {
      active: 'Active Note',
      archived: 'Archived Note',
    },
    searchBar: 'Search by title...',
    noteListInformation: 'No Notes',
  },
};

export {
  headerSectionContent, loginPageContent, registerPageContent, notesPageContent,
};
